<template>
  <div class="ta-bidding-limit">
    <label class="ta-bidding-limit-label">{{ $t('Bidding Limit') }}:</label>
    <div class="ta-bidding-limit-value">{{ customer.term.credit_limit || '(' + $t('No Bidding Limit Set') + ')' }}</div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "BiddingLimit",
  data() {
    return {
      defaultLabel: this.$t("Credit Limit")
    }
  },
  computed: {
    ...mapState(['customer'])
  }
}
</script>

<style lang="scss" scoped>
.ta-bidding-limit {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

#artisioTimedAuctions {
  .ta-bidding-limit-label {
    margin: 0;
  }
}
</style>
